import React from 'react';
import { Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './styles/Search.module.css';

const Search = ({ value, onChange, onSearch, loading, disabled }) => {
  return (
    <div className={styles.searchContainer}>
      <Space size="small">
        <Input
          placeholder="请输入详细地址"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onPressEnter={() => onSearch(value)}
          className={styles.searchInput}
          disabled={disabled}
        />
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={() => onSearch(value)}
          loading={loading}
          disabled={disabled}
        >
          搜索
        </Button>
      </Space>
    </div>
  );
};

export default Search; 